<!-- <div>
    <div class="my-4 row mx-0">
        <div class="col-md-6 ps-md-2 px-0">
            <h5 class="text-start text-primary fw-bold ps-0 ms-0">Preview AOF</h5>
        </div>
        <div class="col-md-6 text-end">
            <div class="d-flex align-items-end h-100 row mt-md-0 mt-2">
                <div class="col-6">
                    <button class="btn btn-white border-primary text-primary  px-md-3 px-3 small" (click)="emailAOF()">Email AOF</button>
                </div>
                <div class="col-6 text-end">
                    <button class="btn btn-white border-primary text-primary  px-md-3 px-1 small" (click)="downloadAOF()">Download AOF</button>
                </div>
            </div>
        </div>
    </div>
</div> -->
<div>
    <iframe *ngIf="objURl" [src]="objURl" style="width: 100%; height: 800px;"></iframe>
</div>
<!-- <object [data]="objURl" style="width: 900px; height: 800px;"></object> -->
<!-- <iframe #pdfViewer width="900px" height="800px" frameborder="0"></iframe> -->



<div class="px-5 my-4 text-end">
    <button class="btn btn-primary  px-4" (click)="nextStage()">Submit</button>
</div>
<!-- <form #frmMain="ngForm" id="frmMain" method="post" class="d-none">
  <input id="msg" name="msg" type="text" [(ngModel)]="esignRequestXml" />
</form> -->
<form [attr.action]="esignApiUrl" method="post" #frmMain style="display: none">
    <input id="msg" name="msg" type="text" [value]="esignRequestXml" />
</form>

<div class="modal fade" id="complete" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title fs-5" id="exampleModalLabel">Thank you for choosing SBI Securities</h1>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                Once submitted you will not be able to view / edit . On confirmation , the application should get
                submitted.
            </div>
            <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-white border-primary text-primary me-3"
                    data-bs-dismiss="modal">Cancel</button>
                <button type="button" class="btn btn-primary me-3" data-bs-dismiss="modal"
                    (click)="stageValidate()">Okay</button>
            </div>
        </div>
    </div>
</div>
<ngx-ui-loader></ngx-ui-loader>
<ngx-ui-loader loaderId="loader2"></ngx-ui-loader>
<app-error-modal #errorComp></app-error-modal>